import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QueryListComponent } from './query-list/query-list.component';
import { CreateQueryComponent } from './create-query/create-query.component';
import { CommonModule } from '@angular/common';
import { UpdateQueryComponent } from './update-query/update-query.component';
import { ViewQueryComponent } from './view-query/view-query.component';
import { ViewPreviousQueryDetailsComponent } from './view-previous-query-details/view-previous-query-details.component';
import { RespondedQueryComponent } from './responded-query/responded-query.component';
import { MyQueryListComponent } from './my-query-list/my-query-list.component';
import { ReopenQueryComponent } from './reopen-query/reopen-query.component';
import { PendingQueryComponent } from './pending-query/pending-query.component';
import { RecycleQueryComponent } from './recycle-query/recycle-query.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'all_query_request', component: QueryListComponent, title: 'Query List' },
      { path: 'responded_query', component: RespondedQueryComponent, title: 'Responded Query' },
      { path: 'my-query', component: MyQueryListComponent, title: 'My Query' },
      { path: 'create-query', component: CreateQueryComponent, title: 'Create Query' },
      { path: 'update-query/:queryCode', component: UpdateQueryComponent, title: 'Update Query' },
      { path: 'view-query/:queryCode', component: ViewQueryComponent, title: 'View Query' },
      { path: 'view-previous-query-details/:queryCode', component: ViewPreviousQueryDetailsComponent},
      { path: 'view-previous-query-details/:queryCode/:calledFromReopen', component: ViewPreviousQueryDetailsComponent},
      { path: 'reopen-query/:queryCode', component: ReopenQueryComponent},
      { path: 'recycle-query/:queryCode', component: RecycleQueryComponent},
      { path: 'create', component: CreateQueryComponent, title: 'Create Query' },
      { path: 'pending-query', component: PendingQueryComponent},
      { path: '', redirectTo: 'all_query_request', pathMatch: 'full' } // Default route
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ClarificationQueryRoutingModule { }
